export function Badge({ badge, badgeLocation, product, size }) {
  if (!badge) return null

  let showOffMessaging = false
  let salePercentage = 0

  if (product && product.variants && product.variants[0]) {
    const variant = product.variants[0]
    const offMessagingString = badge.off_messaging?.join(',') || ''

    if (variant.compare_at_price && variant.compare_at_price !== variant.price) {
      if (badgeLocation === 'PLP' && offMessagingString.includes('PLP')) {
        showOffMessaging = true
      } else if (badgeLocation === 'PDP' && offMessagingString.includes('PDP')) {
        showOffMessaging = true
      }

      if (showOffMessaging) {
        salePercentage = Math.floor(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price)
      }
    }
  }

  const badgeText = badge.text + (showOffMessaging ? ` | Save ${salePercentage}%` : '')
  const sizeClass = size === 'sm' ? 'badge-sm' : 'badge'

  return (
    <p
      style={`--bg-color:${badge.backgroundColor?.value};--fg-color:${badge.foregroundColor?.value}`}
      className={`${sizeClass} w-fit -rotate-1 whitespace-nowrap bg-[--bg-color] text-[--fg-color] sm:group-hover/card:animate-wiggle`}
    >
      {badgeText}
    </p>
  )
}
